import {IRequester, requester} from "../../../libraries/requester";
import {ILinks, links} from "../../../Links";
import {ListMenstrualCyclesDto} from "./dto/list-menstrual-cycles-dto";

class MenstrualCycleService {
    constructor(
        private requester: IRequester,
        private links: ILinks,
    ) {}

    get = async (body?: ListMenstrualCyclesDto) => {
        try {
            const url = new URL(this.links.nltdevskeletons);
            if (body) {
                Object.keys(body).forEach(key => url.searchParams.append(key, body[key]));
            }
            const response = await this.requester.get(url.href);
            return response;
        } catch (error) {
            console.warn('MenstrualCycleService -> list: ', this.links.nltdevskeletons, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }

    addRecommendations = async (body: any) => {
        try {
            const url = this.links.nltdevskeletons + '/set-recommended-type';
            const response = await this.requester.patch(url, body);
            return response;
        } catch (error) {
            console.warn('MenstrualCycleService -> addRecommendations: ', this.links.nltdevskeletons, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }

    removeRecommendations = async (body: any) => {
        try {
            const url = this.links.nltdevskeletons + '/remove-recommended-type';
            const response = await this.requester.patch(url, body);
            return response;
        } catch (error) {
            console.warn('MenstrualCycleService -> removeRecommendations: ', this.links.nltdevskeletons, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }
}

export const menstrualCycleService = new MenstrualCycleService(requester, links);